<template>
    <common-page flex-column>
        <div class="card d-flex flex-row align-items-center mb-1 p-1">
            <b-overlay :show="saveLoading" spinner-variant="primary" spinner-type="grow" spinner-small class="ml-auto">
                <b-button class="ml-1" variant="outline-success" @click="doSave">
                    <i class="fa fa-save" aria-hidden="true"></i>
                    Save
                </b-button>
            </b-overlay>
        </div>
        <div class="d-flex flex-row w-100 h-100">
            <b-overlay :show="resizeFinish" spinner-variant="primary" class="h-100 col">
                <CustomizedDiagramView ref="diagramView"
                                       :img-url="imgUrl"
                                       @pieceClick="handlePieceClick"
                                       @resizeFinish="whenResizeFinish"></CustomizedDiagramView>
            </b-overlay>
            <DrawerHandler ref="drawer" class="col-3">
                <div class="d-flex flex-column">
                    <div class="d-flex flex-row">
                        <b-form-tags v-model="clickedNames"
                                     :tag-validator="tagValidator"
                                     tag-variant="success"
                                     placeholder="Input Code..."></b-form-tags>
                        <b-avatar size="1.6rem"
                                  :variant="multiChange ? 'success' : 'light'"
                                  button class="ml-1"
                                  icon="check-all"
                                  @click="switchMultiChange"></b-avatar>
                    </div>
                    <b-form-text class="mt-1 ml-1 mb-2">
                        输入 <kbd>#all</kbd> 以全选；<kbd>#clear</kbd> 以清空
                    </b-form-text>
                    <DiverseInputGroup ref="inputGroup" :configs="inputGroupConfig"
                                       v-show="clickedNames.length > 0"
                                       @changed="handleValueChange"></DiverseInputGroup>
                </div>
            </DrawerHandler>
        </div>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage";
import CustomizedDiagramView from "@/components/LayoutMaps/openLayers/CustomizedDiagramView";
import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
import DiverseInputGroup from "@/components/workflow/stuffs/DiverseInputGroup";

export default {
    name: "CustomizedDiagramPieceSetting",
    components: {DiverseInputGroup, DrawerHandler, CustomizedDiagramView, CommonPage},
    computed: {
        routerContent() {
            return this.$store.state.routeStore.content;
        },
        pieceCodeList() {
            let tempList = [];
            if (this.mapJson && this.mapJson.features) {
                for (let item of this.mapJson.features) {
                    if (item.properties && item.properties.name) {
                        tempList.push(item.properties.name);
                    }
                }
            }
            return tempList;
        }
    },
    data() {
        return {
            resizeFinish: false,
            imgUrl: '',
            mapJson: {},
            styleJson: {},
            pieceStyles: {},

            inputGroupConfig: [
                {label: '字体大小', name: 'fontSize', type: 'input', format: 'number'},
                {label: '字体大小', name: 'fontSize', type: 'input', format: 'range'},
                {label: '字体颜色', name: 'color', type: 'input', format: 'color'},
                {label: '区块底色', name: 'backgroundColor', type: 'input', format: 'color'},
            ],
            clickedNames: [],
            multiChange: false,
            saveLoading: false,
        }
    },
    watch: {
        clickedNames() {
            if (this.clickedNames.length > 0) {
                let clickedName = this.clickedNames[this.clickedNames.length - 1];
                if (clickedName === '#all') {
                    this.multiChange = true;
                    this.clickedNames.pop();
                    for (let item of this.pieceCodeList) {
                        if (!this.clickedNames.some(f => f === item)) {
                            this.clickedNames.push(item);
                            this.installPieceStyles(item);
                        }
                    }
                } else if (clickedName === '#clear') {
                    this.clickedNames = [];
                }
            }
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            if (this.routerContent.imgUrl) this.imgUrl = this.routerContent.imgUrl;
            if (this.routerContent.mapJson) this.mapJson = JSON.parse(this.routerContent.mapJson);
            if (this.routerContent.styleJson) {
                this.styleJson = JSON.parse(this.routerContent.styleJson);
                if (this.styleJson.hasOwnProperty('pieceStyle')) {
                    this.pieceStyles = this.styleJson.pieceStyle;
                }
            }
            this.$refs.diagramView.setSomeJson(this.mapJson, this.pieceStyles);
        },
        whenResizeFinish() {
            this.resizeFinish = true;
        },
        installPieceStyles(pieceName) {
            let temp = {
                fontSize: 0,//default
                color: '#000000'
            }
            let pieceStyle = this.pieceStyles[pieceName];
            if (!this.pieceStyles.hasOwnProperty(pieceName)) {
                pieceStyle = {
                    label: temp,
                    piece: {}
                };
                this.pieceStyles[pieceName] = pieceStyle;
            } else {
                if (!pieceStyle.hasOwnProperty('label')) {
                    pieceStyle.label = temp;
                }
                if (!pieceStyle.hasOwnProperty('piece')) {
                    pieceStyle.piece = {};
                }
            }
            return pieceStyle;
        },
        handlePieceClick(piece) {
            let pieceName = piece.name;
            if (!this.multiChange) {
                this.clickedNames = [];
            }
            this.clickedNames.push(pieceName);
            let pieceStyle = this.installPieceStyles(pieceName);
            if (this.clickedNames.length === 1) {
                let temp = {
                    fontSize: pieceStyle.label.fontSize,
                    color: pieceStyle.label.color,
                    backgroundColor: pieceStyle.piece.color
                }
                this.$refs.inputGroup.initInputData(temp);
            }
        },
        handleValueChange(val) {
            if (this.clickedNames.length > 0) {
                if (val.fontSize && typeof val.fontSize === 'string') {
                    val.fontSize = Number.parseInt(val.fontSize);
                }
                if (val.fontSize === 0) {
                    val.fontSize = undefined;
                }
                if (val.color && val.color === '#000000') {
                    val.color = undefined;
                }
                if (val.backgroundColor && val.backgroundColor === '#000000') {
                    val.backgroundColor = undefined;
                }
                for (let name of this.clickedNames) {
                    this.pieceStyles[name].label = {
                        fontSize: val.fontSize,
                        color: val.color
                    };
                    this.pieceStyles[name].piece = {
                        color: val.backgroundColor
                    };
                }
                this.$refs.diagramView.readPieceStyle(this.pieceStyles);
            }
        },
        doSave() {
            this.saveLoading = true;
            this.styleJson.pieceStyle = this.pieceStyles;
            console.log(JSON.stringify(this.styleJson));
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_EM_ARCHIVE_URL + "/emSicCustomizedDiagramScd/saveByCode",
                data: {
                    scdCode: this.mapJson.mapName,
                    scdStyleJson: JSON.stringify(this.styleJson)
                }
            }).then(() => {
                this.$message.success("Operation success");
                this.$router.go(-1);
            }).finally(() => this.saveLoading = false);
        },
        switchMultiChange() {
            this.multiChange = !this.multiChange;
            if (!this.multiChange && this.clickedNames.length > 1) {
                this.clickedNames = [this.clickedNames[0]];
            }
        },
        tagValidator(tag) {
            return this.pieceCodeList.some(f => f === tag) || tag === '#all' || tag === '#clear';
        },
    }
}
</script>

<style scoped>

</style>